import React, { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";

const RomScore = (props) => {
  let { id } = props;
  const [hasNoData, setHasNoData] = useState(true);
  const [dataLoading, setDataLoading] = useState(true);
  const [isRomPopupOpen, setRomPopupOpen] = useState(false);
  const [romPopupData, setRomPopupData] = useState({});
  const [testData, setTestData] = useState({
    test_date: "",
    test_score: 0,
    score_diff_from_last: 0,
  });

  useEffect(() => {
    if (id !== undefined) {
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_therapist/rom_test_details", { id })
        .then((res) => {
          if (res.data.responseData) {
            if (res.data.responseData.message == "no data found") {
              setHasNoData(true);
            } else {
              setHasNoData(false);
            }

            setDataLoading(false);

            if (res.data.responseData) {
              setTestData(res.data.responseData);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [id]);

  const handleRomPopup = (exerciseData) => {
    var exrDataTotal = {};
    exrDataTotal.exercise_name = exerciseData.exercise_name;
    var exrDataSet = [];
    if (exerciseData && exerciseData.first_exercise_data) {
      exrDataSet[0] = exerciseData.first_exercise_data;
    }
    if (exerciseData && exerciseData.exercise_data) {
      exrDataSet[1] = exerciseData.exercise_data;
    }

    exrDataTotal.exercise_data = exrDataSet;
    setRomPopupOpen(!isRomPopupOpen);
    setRomPopupData(exrDataTotal);
  };

  return (
    <>
      <div className="patient_list_container pain_score_container">
        <div className="rom_score_top">
          <div className="title_container">
            <div className="title_painscore">ROM Score</div>
          </div>
          {dataLoading ? (
            <div className="p_load"></div>
          ) : hasNoData ? (
            <div className="score_card_top">No Data Found.</div>
          ) : (
            <>
              {testData &&
                testData.map((exercise, e) => (
                  <div key={e} className="score_card">
                    <div className="score_card_top">
                      <div
                        className={
                          "score_card_text" +
                          (exercise?.first_exercise_data || exercise?.exercise_data ? "" : " score_card_text_no_info")
                        }
                        onClick={() =>
                          exercise?.first_exercise_data || exercise?.exercise_data ? handleRomPopup(exercise) : ""
                        }
                      >
                        {exercise?.exercise_name}
                      </div>
                    </div>
                    {exercise?.first_exercise_data || exercise?.exercise_data ? (
                      <>
                        <div className="score_card_separator">
                          {exercise?.first_exercise_data && (
                            <>
                              <div className="score_card_main">
                                {exercise?.first_exercise_data?.test_score}
                                {"\xB0"}
                              </div>
                              <div className="score_card_bottom">
                                First Test Taken at: {moment(exercise?.first_exercise_data?.test_date).format("l")}
                              </div>
                            </>
                          )}
                        </div>
                        <div className="score_card_separator">
                          {exercise?.exercise_data && (
                            <>
                              <div className="score_card_main">
                                {exercise?.exercise_data?.test_score}
                                {"\xB0"}
                              </div>
                              <div
                                className={
                                  "score_card_points_positive " +
                                  (exercise?.exercise_data?.score_diff_from_last < 0
                                    ? " score_card_points_red_negative"
                                    : "")
                                }
                              >
                                <div>
                                  <span>{exercise?.exercise_data?.score_diff_from_last}% *</span>
                                </div>
                              </div>
                              <div className="score_card_bottom">
                                Test Taken at: {moment(exercise?.exercise_data?.test_date).format("l")}
                              </div>
                              {/* <div className="score_text_small">*compared to the previous test</div> */}
                            </>
                          )}
                        </div>
                      </>
                    ) : (
                      <div className="score_card_no_found">No Data Found.</div>
                    )}
                  </div>
                ))}
            </>
          )}
        </div>
      </div>
      {isRomPopupOpen && (
        <>
          <div className="dlt_wrapper">
            <div className="approval_close tsk_info_cls" onClick={() => handleRomPopup({})}></div>
            <div className="dash_task_info_pop">
              <div>
                <div className="ab_dets_immutable">Exercise Details</div>
                <div className="ab_success_row">
                  <b>{romPopupData?.exercise_name}</b>
                  <br />
                  <br />
                </div>
                <div className="dash_task_table">
                  <div className="dash_task_single_row dt_sr_no_bord_bold dt_bord_addit">
                    <div className="dt_rep">
                      <div className="dt_shrink">#</div>
                    </div>
                    <div className="dash_task_expand dt_exp2 task_exrc_centered dash_task_exrc_name">Exercise Name</div>
                    <div className="dash_task_reg dt_sd_top_desc task_exrc_centered">
                      Completed Reps
                      <div className="dt_sd_addit_desc task_exrc_centered">Actual vs. Target</div>
                    </div>
                    <div className="dash_task_reg dt_sd_top_desc task_exrc_centered">
                      Average Hold
                      <div className="dt_sd_addit_desc task_exrc_centered">Actual vs Target vs Previous</div>
                      <div className="dt_sd_addit_desc task_exrc_centered">In seconds</div>
                    </div>
                    <div className="dash_task_reg dt_sd_top_desc task_exrc_centered">
                      Time per Rep
                      <div className="dt_sd_addit_desc task_exrc_centered">Actual vs Previous</div>
                      <div className="dt_sd_addit_desc task_exrc_centered">In seconds</div>
                    </div>
                    <div className="dash_task_reg dt_sd_top_desc task_exrc_centered">
                      Range of Motion
                      <div className="dt_sd_addit_desc task_exrc_centered">Actual vs Target vs Previous</div>
                      <div className="dt_sd_addit_desc task_exrc_centered">In Degrees</div>
                    </div>
                  </div>
                  {romPopupData?.exercise_data &&
                    romPopupData?.exercise_data.map((activity, act) => (
                      <div key={act}>
                        <div className="score_card_text_dets_test_title">{act == 0 ? "First Test" : "Latest Test"}</div>
                        <div
                          className={
                            "dash_task_single_row dash_task_sr_marg dt_sd_sub_open"
                            // + (singleExrDataOpen === act ? " dt_sd_sub_open" : "")
                          }
                          style={{ backgroundImage: "none" }}
                        >
                          <div className="dt_shrink_in_col">
                            {act + 1}
                            {activity.hasVideo > 0 && (
                              <div
                                className="smallPlay"
                                //onClick={() => openPlayVideo(activity.id)}
                              ></div>
                            )}
                            <div
                              className={
                                "status_exercise_position" +
                                (activity.is_complete === 1 && activity.activity_skipped === 0
                                  ? " pain_color_green"
                                  : activity.activity_skipped === 1
                                  ? " pain_color_red"
                                  : " pain_color_yellow")
                              }
                            >
                              <div className="dash_tooltip_hold dash_tooltip_hold_margin_status">
                                <div className="dash_tooltip">
                                  <div className="dash_tooltip_text">
                                    {activity.is_complete === 1 && activity.activity_skipped === 0
                                      ? "Completed"
                                      : activity.activity_skipped === 1
                                      ? "Skipped"
                                      : "Pending"}
                                  </div>
                                </div>
                                <div className="dash_arrow"></div>
                              </div>
                            </div>
                            {activity.exercise_difficulty > 0 && (
                              <div className="status_exercise_difficulty ">
                                {activity.exercise_difficulty === 1
                                  ? "H"
                                  : activity.exercise_difficulty === 2
                                  ? "E"
                                  : activity.exercise_difficulty === 3
                                  ? "P"
                                  : ""}

                                <div className="dash_tooltip_hold dash_tooltip_hold_margin_status">
                                  <div className="dash_tooltip">
                                    <div className="dash_tooltip_text">
                                      {activity.exercise_difficulty === 1
                                        ? "Hard"
                                        : activity.exercise_difficulty === 2
                                        ? "Easy"
                                        : activity.exercise_difficulty === 3
                                        ? "Perfect"
                                        : ""}
                                    </div>
                                  </div>
                                  <div className="dash_arrow"></div>
                                </div>
                              </div>
                            )}
                            {activity.activity_skipped === 1 && (
                              <div
                                className={
                                  "status_exercise_pain" +
                                  (activity.was_painful === 1 ? " square_color_red" : " square_color_green")
                                }
                              >
                                <div className="dash_tooltip_hold dash_tooltip_hold_margin_status">
                                  <div className="dash_tooltip">
                                    <div className="dash_tooltip_text">
                                      {activity.was_painful === 1 ? "Painful" : "Not painful"}
                                    </div>
                                  </div>
                                  <div className="dash_arrow"></div>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="dash_task_expand dt_exp2 task_exrc_centered">{activity.display_name}</div>
                          <div className="dash_task_reg task_exrc_centered">
                            {activity.reps_done || 0}/{activity.reps}
                          </div>
                          {activity.hold_in_seconds > 0 ? (
                            <div className="dash_task_reg task_exrc_centered">
                              {activity.hold_done} / {activity.hold_in_seconds} / {activity.previous_hold}
                            </div>
                          ) : (
                            <div className="dash_task_reg task_exrc_centered">No Hold</div>
                          )}
                          {activity.is_complete === 1 && activity.activity_skipped === 0 ? (
                            <div className="dash_task_reg task_exrc_centered">
                              {activity.rep_seconds}/{activity.rep_seconds_previous}
                            </div>
                          ) : (
                            <div className="dash_task_reg task_exrc_centered">-</div>
                          )}
                          {activity.is_complete === 1 && activity.activity_skipped === 0 && activity.target_rom > 0 ? (
                            <div className="dash_task_reg task_exrc_centered">
                              {activity.rom_max}
                              {"\xB0"}/{activity.target_rom}
                              {"\xB0"}/{activity.rom_maxPrev > 0 ? activity.rom_maxPrev : "N/A"}
                              {"\xB0"}
                            </div>
                          ) : (
                            <div className="dash_task_reg task_exrc_centered">N/A</div>
                          )}
                        </div>
                        {activity.is_complete === 1 && activity.activity_skipped === 0 && (
                          <div className="dash_additional_info">
                            <div className="dash_task_single_row dt_sr_no_bord_bold dt_no_bord_addit">
                              {/* <div className="dt_shrink2">Rep#</div> */}
                              <div className="dt_rep">
                                <div className="dt_shrink">#</div>
                              </div>
                              <div className="dash_task_reg dt_sd_top_desc task_exrc_centered">
                                Actual Hold vs Target vs Previous
                                <div className="dt_sd_addit_desc task_exrc_centered">In seconds</div>
                              </div>
                              <div className="dash_task_reg dt_time_rep task_exrc_centered">
                                Time per Rep In Seconds
                                {/* <div className="dt_in_secs">(In Seconds)</div> */}
                              </div>
                              <div className="dash_task_reg dt_sd_sub dt_act_rom_target task_exrc_centered">
                                Actual ROM vs Target vs Previous
                                <div className="dt_sd_addit_desc task_exrc_centered">In Degrees</div>
                                {/* <div className="dt_in_degrees">(In Degrees)</div> */}
                              </div>
                            </div>
                            {activity.repsData != undefined && activity.repsData.length > 0 ? (
                              <div>
                                {activity.repsData.map((rep, r) => (
                                  <div
                                    key={rep.id}
                                    className="dash_task_single_row dash_task_sr_no_bord dash_task_sr_marg_btm"
                                  >
                                    {/* <div className="dt_shrink_in_col2">{rep.rep_num}</div> */}
                                    <div className="dash_task_reg dt_rep">{rep.rep_num}</div>
                                    {activity.hold_in_seconds > 0 ? (
                                      <div className="dash_task_reg task_exrc_centered">
                                        {rep.rep_hold} / {activity.hold_in_seconds} / {activity.previous_hold}
                                      </div>
                                    ) : (
                                      <div className="dash_task_reg task_exrc_centered">No Hold</div>
                                    )}
                                    <div className="dash_task_reg task_exrc_centered">{rep.rep_time}</div>
                                    {activity.target_rom > 0 ? (
                                      <div className="dash_task_reg task_exrc_centered">
                                        {rep.rep_rom}
                                        {"\xB0"}/{activity.target_rom}
                                        {"\xB0"}/{activity.rom_maxPrev > 0 ? activity.rom_maxPrev : "N/A"}
                                        {"\xB0"}
                                      </div>
                                    ) : (
                                      <div className="dash_task_reg task_exrc_centered">N/A</div>
                                    )}
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div className="dash_task_single_row dash_task_sr_no_bord dash_task_sr_marg_btm">
                                <div className="dash_task_reg dt_rep">1</div>
                                {activity.hold_in_seconds > 0 ? (
                                  <div className="dash_task_reg task_exrc_centered">
                                    {activity.hold_done} / {activity.hold_in_seconds} / {activity.previous_hold}
                                  </div>
                                ) : (
                                  <div className="dash_task_reg task_exrc_centered">No Hold</div>
                                )}
                                <div className="dash_task_reg task_exrc_centered">
                                  {activity.rep_seconds}.{activity.rep_seconds_previous}
                                </div>
                                {activity.target_rom > 0 ? (
                                  <div className="dash_task_reg task_exrc_centered">
                                    {activity.rom_max}
                                    {"\xB0"}/{activity.target_rom}
                                    {"\xB0"}/{activity.rom_maxPrev > 0 ? activity.rom_maxPrev : "N/A"}
                                    {"\xB0"}
                                  </div>
                                ) : (
                                  <div className="dash_task_reg task_exrc_centered">N/A</div>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    ))}
                </div>
                <div className="ab_success_row"></div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default RomScore;
